import React from 'react';
import downloadpdficon from '../../../assets/images/downloadpdficon.svg'
import { Accordion, Table } from 'react-bootstrap';
import './oaastab.css';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

// Extend jsPDF type to include autoTable
declare module 'jspdf' {
    interface jsPDF {
        autoTable: typeof autoTable;
        lastAutoTable: {
            finalY: number;
        };
    }
}

const Oaastab: React.FC = () => {
    const downloadPDF = () => {
        const doc = new jsPDF();
        
        // Manually attach autoTable plugin
        (doc as any).autoTable = autoTable;
        
        // Add title
        doc.setFontSize(20);
        doc.text('Audit Dashboard Report', 14, 20);
        
        // Add timestamp
        doc.setFontSize(10);
        doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, 30);
        
        // Extract data from actual HTML tables in the DOM
        const extractTableData = () => {
            const tables = document.querySelectorAll('.common_table');
            const auditSections: any[] = [];
            
            tables.forEach((table, index) => {
                const accordionItem = table.closest('.accordion-item');
                const header = accordionItem?.querySelector('.accordion-header');
                
                if (header) {
                    // Extract section title and summary
                    const headerText = header.textContent || '';
                    const titleMatch = headerText.match(/([^:]+): (.*)/);
                    
                    if (titleMatch) {
                        const title = titleMatch[1].trim();
                        const summary = titleMatch[2].trim();
                        
                        // Extract table headers and data
                        const headers = Array.from(table.querySelectorAll('th')).map(th => th.textContent || '');
                        const data = Array.from(table.querySelectorAll('tbody tr')).map(tr => {
                            return Array.from(tr.querySelectorAll('td')).map(td => td.textContent || '');
                        });
                        
                        // Add section data to auditSections array
                        auditSections.push({
                            title,
                            summary,
                            headers,
                            data
                        });
                    }
                }
            });
            
            return auditSections;
        };
        
        const auditSections = extractTableData();
        
        let yPosition = 40;
        
        // Add each audit section
        auditSections.forEach((section, index) => {
            // Check if we need a new page
            if (yPosition > 250) {
                doc.addPage();
                yPosition = 20;
            }
            
            // Add section title
            doc.setFontSize(14);
            doc.text(section.title, 14, yPosition);
            
            doc.setFontSize(10);
            doc.text(section.summary, 14, yPosition + 7);
            
            yPosition += 20;
            
            // Add table using autoTable
            autoTable(doc, {
                head: [section.headers],
                body: section.data,
                startY: yPosition,
                theme: 'grid',
                styles: {
                    fontSize: 8,
                    cellPadding: 3,
                    overflow: 'linebreak'
                },
                headStyles: {
                    fillColor: [66, 139, 202],
                    textColor: 255,
                    fontStyle: 'bold'
                },
                columnStyles: {
                    0: { cellWidth: 40 }, // Item column
                    1: { cellWidth: 20 }, // Comp column
                    2: { cellWidth: 20 }, // Issues column
                    3: { cellWidth: 20 }, // Risk column
                    4: { cellWidth: 'auto' } // Note column
                },
                didDrawPage: (data: any) => {
                    // Add page number at bottom
                    doc.setFontSize(8);
                    const pageNumber = (doc.internal as any).getNumberOfPages ? 
                        (doc.internal as any).getNumberOfPages() : 
                        doc.getCurrentPageInfo()?.pageNumber || 1;
                    doc.text(`Page ${pageNumber}`, doc.internal.pageSize.width - 20, doc.internal.pageSize.height - 10);
                }
            });
            
            yPosition = doc.lastAutoTable.finalY + 15;
        });
        
        // Save the PDF
        doc.save('audit-dashboard-report.pdf');
    };
    return (
        <>
            <div className="common_content_inner mby_t_16">
                <div className="top top_bar_flx">
                    <div className="top_bar_tittle">
                        <h2>Audit Dashboard</h2>
                    </div>
                    <div className="top_right_flx">
                        <button className='btn_flx download_pdf' onClick={downloadPDF}>Download PDF <img style={{ width: '1.5rem' }} src={downloadpdficon} alt="downloadpdficon" /></button>
                    </div>
                </div>
                <div className="my_accordian">
                    <Accordion>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>SCA Policy Review <span><strong>Avg</strong>: 75%, <strong>Issues</strong>: 6, <strong>Risk</strong>: High</span></Accordion.Header>
                            <Accordion.Body>
                                <Table responsive className='common_table'>
                                    <thead>
                                        <tr>
                                            <th>Item</th>
                                            <th>Comp</th>
                                            <th>Issues</th>
                                            <th>Risk</th>
                                            <th>Note</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div className="ar_flx">
                                                    <p>AR 1.1 a</p>
                                                    <p>Policies for LOC assessments identify requirements for completing the LOC assessment tool</p>
                                                </div>
                                            </td>
                                            <td>65%</td>
                                            <td>1</td>
                                            <td>High</td>
                                            <td>Review SCA’s policy on LOC assessments to confirm it includes process, timelines, and reassessment criteria.</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="ar_flx">
                                                    <p>AR 1.1 b</p>
                                                    <p>SCs conducting assessments are certified</p>
                                                </div>
                                            </td>
                                            <td>92%</td>
                                            <td>1</td>
                                            <td>Medium</td>
                                            <td>Verify SCs are certified to conduct LOC assessments, reviewing personnel files and certification records.</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="ar_flx">
                                                    <p>AR 2.1 a</p>
                                                    <p>Policy defines risk factors and mitigation strategies for health and safety</p>
                                                </div>
                                            </td>
                                            <td>65%</td>
                                            <td>3</td>
                                            <td>Low</td>
                                            <td>Review SCA’s policy for a clear definition of risks and strategies for managing them (e.g., health, safety, behavioral).</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="ar_flx">
                                                    <p>AR 1.1 a</p>
                                                    <p>Policies for LOC assessments identify requirements for completing the LOC assessment tool</p>
                                                </div>
                                            </td>
                                            <td>65%</td>
                                            <td>1</td>
                                            <td>High</td>
                                            <td>Review SCA’s policy on LOC assessments to confirm it includes process, timelines, and reassessment criteria.</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="ar_flx">
                                                    <p>AR 1.1 a</p>
                                                    <p>Policies for LOC assessments identify requirements for completing the LOC assessment tool</p>
                                                </div>
                                            </td>
                                            <td>65%</td>
                                            <td>1</td>
                                            <td>High</td>
                                            <td>Review SCA’s policy on LOC assessments to confirm it includes process, timelines, and reassessment criteria.</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="ar_flx">
                                                    <p>AR 1.1 a</p>
                                                    <p>Policies for LOC assessments identify requirements for completing the LOC assessment tool</p>
                                                </div>
                                            </td>
                                            <td>65%</td>
                                            <td>1</td>
                                            <td>High</td>
                                            <td>Review SCA’s policy on LOC assessments to confirm it includes process, timelines, and reassessment criteria.</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="ar_flx">
                                                    <p>AR 1.1 a</p>
                                                    <p>Policies for LOC assessments identify requirements for completing the LOC assessment tool</p>
                                                </div>
                                            </td>
                                            <td>65%</td>
                                            <td>1</td>
                                            <td>High</td>
                                            <td>Review SCA’s policy on LOC assessments to confirm it includes process, timelines, and reassessment criteria.</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="ar_flx">
                                                    <p>AR 1.1 a</p>
                                                    <p>Policies for LOC assessments identify requirements for completing the LOC assessment tool</p>
                                                </div>
                                            </td>
                                            <td>65%</td>
                                            <td>1</td>
                                            <td>High</td>
                                            <td>Review SCA’s policy on LOC assessments to confirm it includes process, timelines, and reassessment criteria.</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="1">
                            <Accordion.Header>Employee File Review <span><strong>Avg</strong>: 75%, <strong>Issues</strong>: 6, <strong>Risk</strong>: High</span></Accordion.Header>
                            <Accordion.Body>
                                <Table responsive className='common_table'>
                                    <thead>
                                        <tr>
                                            <th>Item</th>
                                            <th>Comp</th>
                                            <th>Issues</th>
                                            <th>Risk</th>
                                            <th>Note</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div className="ar_flx">
                                                    <p>AR 1.1 a</p>
                                                    <p>Policies for LOC assessments identify requirements for completing the LOC assessment tool</p>
                                                </div>
                                            </td>
                                            <td>65%</td>
                                            <td>1</td>
                                            <td>High</td>
                                            <td>Review SCA’s policy on LOC assessments to confirm it includes process, timelines, and reassessment criteria.</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="ar_flx">
                                                    <p>AR 1.1 b</p>
                                                    <p>SCs conducting assessments are certified</p>
                                                </div>
                                            </td>
                                            <td>92%</td>
                                            <td>1</td>
                                            <td>Medium</td>
                                            <td>Verify SCs are certified to conduct LOC assessments, reviewing personnel files and certification records.</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="ar_flx">
                                                    <p>AR 2.1 a</p>
                                                    <p>Policy defines risk factors and mitigation strategies for health and safety</p>
                                                </div>
                                            </td>
                                            <td>65%</td>
                                            <td>3</td>
                                            <td>Low</td>
                                            <td>Review SCA’s policy for a clear definition of risks and strategies for managing them (e.g., health, safety, behavioral).</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="ar_flx">
                                                    <p>AR 1.1 a</p>
                                                    <p>Policies for LOC assessments identify requirements for completing the LOC assessment tool</p>
                                                </div>
                                            </td>
                                            <td>65%</td>
                                            <td>1</td>
                                            <td>High</td>
                                            <td>Review SCA’s policy on LOC assessments to confirm it includes process, timelines, and reassessment criteria.</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="ar_flx">
                                                    <p>AR 1.1 a</p>
                                                    <p>Policies for LOC assessments identify requirements for completing the LOC assessment tool</p>
                                                </div>
                                            </td>
                                            <td>65%</td>
                                            <td>1</td>
                                            <td>High</td>
                                            <td>Review SCA’s policy on LOC assessments to confirm it includes process, timelines, and reassessment criteria.</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="ar_flx">
                                                    <p>AR 1.1 a</p>
                                                    <p>Policies for LOC assessments identify requirements for completing the LOC assessment tool</p>
                                                </div>
                                            </td>
                                            <td>65%</td>
                                            <td>1</td>
                                            <td>High</td>
                                            <td>Review SCA’s policy on LOC assessments to confirm it includes process, timelines, and reassessment criteria.</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="ar_flx">
                                                    <p>AR 1.1 a</p>
                                                    <p>Policies for LOC assessments identify requirements for completing the LOC assessment tool</p>
                                                </div>
                                            </td>
                                            <td>65%</td>
                                            <td>1</td>
                                            <td>High</td>
                                            <td>Review SCA’s policy on LOC assessments to confirm it includes process, timelines, and reassessment criteria.</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="ar_flx">
                                                    <p>AR 1.1 a</p>
                                                    <p>Policies for LOC assessments identify requirements for completing the LOC assessment tool</p>
                                                </div>
                                            </td>
                                            <td>65%</td>
                                            <td>1</td>
                                            <td>High</td>
                                            <td>Review SCA’s policy on LOC assessments to confirm it includes process, timelines, and reassessment criteria.</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="2">
                            <Accordion.Header>Participant Record Review <span><strong>Avg</strong>: 75%, <strong>Issues</strong>: 6, <strong>Risk</strong>: High</span></Accordion.Header>
                            <Accordion.Body>
                                <Table responsive className='common_table'>
                                    <thead>
                                        <tr>
                                            <th>Item</th>
                                            <th>Comp</th>
                                            <th>Issues</th>
                                            <th>Risk</th>
                                            <th>Note</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div className="ar_flx">
                                                    <p>AR 1.1 a</p>
                                                    <p>Policies for LOC assessments identify requirements for completing the LOC assessment tool</p>
                                                </div>
                                            </td>
                                            <td>65%</td>
                                            <td>1</td>
                                            <td>High</td>
                                            <td>Review SCA’s policy on LOC assessments to confirm it includes process, timelines, and reassessment criteria.</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="ar_flx">
                                                    <p>AR 1.1 b</p>
                                                    <p>SCs conducting assessments are certified</p>
                                                </div>
                                            </td>
                                            <td>92%</td>
                                            <td>1</td>
                                            <td>Medium</td>
                                            <td>Verify SCs are certified to conduct LOC assessments, reviewing personnel files and certification records.</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="ar_flx">
                                                    <p>AR 2.1 a</p>
                                                    <p>Policy defines risk factors and mitigation strategies for health and safety</p>
                                                </div>
                                            </td>
                                            <td>65%</td>
                                            <td>3</td>
                                            <td>Low</td>
                                            <td>Review SCA’s policy for a clear definition of risks and strategies for managing them (e.g., health, safety, behavioral).</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="ar_flx">
                                                    <p>AR 1.1 a</p>
                                                    <p>Policies for LOC assessments identify requirements for completing the LOC assessment tool</p>
                                                </div>
                                            </td>
                                            <td>65%</td>
                                            <td>1</td>
                                            <td>High</td>
                                            <td>Review SCA’s policy on LOC assessments to confirm it includes process, timelines, and reassessment criteria.</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="ar_flx">
                                                    <p>AR 1.1 a</p>
                                                    <p>Policies for LOC assessments identify requirements for completing the LOC assessment tool</p>
                                                </div>
                                            </td>
                                            <td>65%</td>
                                            <td>1</td>
                                            <td>High</td>
                                            <td>Review SCA’s policy on LOC assessments to confirm it includes process, timelines, and reassessment criteria.</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="ar_flx">
                                                    <p>AR 1.1 a</p>
                                                    <p>Policies for LOC assessments identify requirements for completing the LOC assessment tool</p>
                                                </div>
                                            </td>
                                            <td>65%</td>
                                            <td>1</td>
                                            <td>High</td>
                                            <td>Review SCA’s policy on LOC assessments to confirm it includes process, timelines, and reassessment criteria.</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="ar_flx">
                                                    <p>AR 1.1 a</p>
                                                    <p>Policies for LOC assessments identify requirements for completing the LOC assessment tool</p>
                                                </div>
                                            </td>
                                            <td>65%</td>
                                            <td>1</td>
                                            <td>High</td>
                                            <td>Review SCA’s policy on LOC assessments to confirm it includes process, timelines, and reassessment criteria.</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="ar_flx">
                                                    <p>AR 1.1 a</p>
                                                    <p>Policies for LOC assessments identify requirements for completing the LOC assessment tool</p>
                                                </div>
                                            </td>
                                            <td>65%</td>
                                            <td>1</td>
                                            <td>High</td>
                                            <td>Review SCA’s policy on LOC assessments to confirm it includes process, timelines, and reassessment criteria.</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </div>
        </>
    );
};

export default Oaastab;